<script>
import { IconExclamationCircle } from '@tabler/icons-vue';
import AppWell from '@/Shared/AppWell.vue';
import AppCard from '@/Shared/AppCard.vue';
import PageSection from '@/Shared/PageSection.vue';
import SubmitFormButton from '../../../Activities/Subactivities/SubmitFormButton.vue';
import SurveyQuestionReportLinearScale from './SurveyQuestionReportLinearScale.vue';
import SurveyQuestionReportLongAnswer from './SurveyQuestionReportLongAnswer.vue';
import SurveyQuestionReportMultipleLongAnswer from './SurveyQuestionReportMultipleLongAnswer.vue';
import SurveyQuestionReportCheckboxes from './SurveyQuestionReportCheckboxes.vue';
import SurveyQuestionReportMultipleChoice from './SurveyQuestionReportMultipleChoice.vue';
import PageSectionCollapsible from '../../../../../Shared/PageSectionCollapsible.vue';
import ZoomableImage from '../../../../../components/ZoomableImage.vue';
import ZoomableAvatar from '../../../../../components/ZoomableAvatar.vue';
import InertiaSquareLinkButton from '../../../../../components/InertiaSquareLinkButton.vue';

export default {
    components: {
        InertiaSquareLinkButton,
        ZoomableAvatar,
        ZoomableImage,
        PageSectionCollapsible,
        AppWell,
        AppCard,
        PageSection,
        SubmitFormButton,
        IconExclamationCircle,
        checkboxes: SurveyQuestionReportCheckboxes,
        multiple_choice: SurveyQuestionReportMultipleChoice,
        linear_scale: SurveyQuestionReportLinearScale,
        short_answer: SurveyQuestionReportLongAnswer,
        long_answer: SurveyQuestionReportLongAnswer,
        multiple_long_answer: SurveyQuestionReportMultipleLongAnswer,
    },
    props: {
        survey: {
            type: Object,
            required: true,
        },
        report: {
            type: Object,
            required: true,
        },
    },
};
</script>

<template>
    <div class="mt-1">
        <PageSection>
            <template v-slot:title>
                {{ survey.title }}
            </template>
            <AppCard>
                <p class="whitespace-pre-line p-2">{{ survey.description }}</p>
            </AppCard>
        </PageSection>
        <PageSectionCollapsible v-if="report.missing.length">
            <template v-slot:title> {{ $t('messages.without_responses') }} ({{ report.missing.length }}) </template>
            <div class="md:grid md:grid-cols-12 md:gap-6">
                <div
                    class="col-span-12 md:col-span-6 lg:col-span-3"
                    v-for="student in report.missing"
                    :key="student.id"
                >
                    <AppCard>
                        <div class="flex gap-2 items-center">
                            <div>
                                <ZoomableAvatar :avatar="student.avatar_or_default" />
                            </div>
                            <div>
                                {{ student.text }}
                            </div>
                        </div>
                    </AppCard>
                </div>
            </div>
        </PageSectionCollapsible>
        <div class="mt-5 flex flex-col gap-8">
            <PageSection v-for="section in report.sections" :key="section.id">
                <template v-slot:title v-if="section.title">
                    {{ section.title }}
                </template>
                <template v-slot:subtitle v-if="section.subtitle">
                    {{ section.description }}
                </template>
                <div class="p-2">
                    <div class="mt-3 flex flex-col gap-4">
                        <div v-for="question in section.questions" :key="question.position">
                            <AppCard :id="`q_${question.id}`">
                                <div class="p-1">
                                    <div class="flex justify-between">
                                        <div>
                                            <span>{{ question.title }}</span>
                                            <span v-if="question.is_required" class="text-red-600"> *</span>
                                        </div>
                                        <div v-if="question.links">
                                            <InertiaSquareLinkButton
                                                action="analysis"
                                                :href="question.links.survey_answers_similarity"
                                                v-if="question.links.survey_answers_similarity"
                                            />
                                        </div>
                                    </div>
                                    <div v-if="question.description" class="mt-1">
                                        <p class="text-gray-700">{{ question.description }}</p>
                                    </div>
                                    <div v-show="false">
                                        {{ question.type }}
                                    </div>
                                    <div class="mt-3">
                                        <component
                                            :is="question.type"
                                            :report="question.report"
                                            :students="report.students"
                                        />
                                    </div>
                                </div>
                            </AppCard>
                        </div>
                    </div>
                </div>
            </PageSection>
        </div>
    </div>
</template>
